import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
} from '@angular/core';
import { BD_UI_FILE_INPUT_CONFIG_DEFAULT, BdUiFileInputConfig } from './config';
import { Button } from 'primeng/button';
import { FileSelectEvent, FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'bd-ui-file-input',
  template: `
    @if (!file()) {
      <div>
        <p-fileupload
          mode="basic"
          name="file-select"
          chooseIcon="pi pi-upload"
          [accept]="config().accept"
          (onSelect)="onFileSelect($event)"
          [auto]="true"
          chooseLabel="Auswählen"
          i18n-chooseLabel
        />
      </div>
    } @else {
      <div class="flex flex-row gap-6 file-info">
        <div class="flex-1">
          <span class="filename">{{ file()?.name }}</span>
        </div>
        <div class="basis-10">
          <p-button
            icon="pi pi-trash"
            severity="danger"
            [text]="true"
            [rounded]="true"
            ariaLabel="Datei entfernen"
            title="Datei entfernen"
            (onClick)="onFileRemove()"
          />
        </div>
      </div>
    }
  `,
  styles: `
    .filename {
      line-height: 40px;
      font-weight: bold;
    }

    .file-info {
      background-color: #f5f5f5;
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 8px 12px;
      align-items: center;
    }
  `,
  imports: [Button, FileUpload],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BdUiFileInputComponent {
  readonly file = model<File | undefined>(undefined);
  readonly config = input<BdUiFileInputConfig>(BD_UI_FILE_INPUT_CONFIG_DEFAULT);
  readonly disabled = input(false);

  public onFileSelect(event: FileSelectEvent) {
    const files = event.files;
    if (files.length > 0) {
      this.file.set(files[0]);
    }
  }

  public onFileRemove() {
    this.file.set(undefined);
  }
}
